import axios from "axios";

export const state = {
    alevelsubjects: [],
};

export const getters = {
    alevelsubjects: state => state.alevelsubjects,
};

export const mutations = {
    setAsubjects(state, newValue) {
        state.alevelsubjects = newValue
    },
};

export const actions = {
    fetchAlevelSubjects({ commit }) {
        axios.get('/alevelsubjects').then(res => {
            commit('setAsubjects', res.data.alevelsubjects);
        })
    },
};
